package navigation.root.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.features.authentication.domain.models.CheckModel
import com.essntl.features.authentication.ui.auth.AuthScreen
import com.essntl.features.authentication.ui.auth.AuthEvent
import com.essntl.features.authentication.ui.auth.AuthScreenDemo
import core.config.buildFlavor

object AuthScreenNav : Screen {

    @Composable
    override fun Content() {
        val checkScreenModel = koinScreenModel<AuthScreenModel>()
        val checkState by checkScreenModel.state.collectAsState()

        LaunchedEffect(checkState.checkSubmit.isSuccess) {
            if (checkState.checkSubmit.isSuccess) {
                checkState.checkSubmit.data?.let {
                    if (it.state == CheckModel.State.NO_TENANT_FOUND)
                        checkScreenModel.onEvent(AuthEvent.UpdateEmailError)
                }
            }
        }

        LaunchedEffect(
            checkState.registerSubmit.isSuccess,
        ) {
            if (checkState.registerSubmit.isSuccess)
                checkScreenModel.onEvent(AuthEvent.ClearRegister)
        }

        LaunchedEffect(
            checkState.loginSubmit.isSuccess,
        ) {
            if (checkState.loginSubmit.isSuccess)
                checkScreenModel.onEvent(AuthEvent.Clear)
        }

        if (buildFlavor.isDemo)
            AuthScreenDemo(
                state = checkState,
                validation = checkScreenModel.validation,
                onEvent = checkScreenModel::onEvent,
            )
        else
            AuthScreen(
                state = checkState,
                validation = checkScreenModel.validation,
                onEvent = checkScreenModel::onEvent,
            )
    }
}